webpackJsonp([200000886538636],{

/***/ 911:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"title":"China’s coming Austrian collapse","createdAt":"14 hours ago","by":"Zweihander","comments":[{"text":"There might be truth to this article but its bias and demeaning tone are off-putting. It makes it hard to take the author seriously.","by":"ahmedalsudani","timeISO":"7 hours ago"}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---comment-17770230-d6cd8019ef72eed420cd.js